module.exports = __webpack_public_path__ + "static/iPhone-XR-isometricMockupBApp-29aaa65e3283c9f8a00fd201140181b2.webp";